// One slow editorial marquee — low-contrast mono type, generous gaps.
// Pure CSS animation; the global reduced-motion rule stills it.
const ITEMS = [
    "We build what the problem requires",
    "Observe",
    "Question",
    "Synthesize",
    "Act",
    "Built at Titan Haven",
    "Operated for the long term",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="px-8 text-xs tracking-[0.3em] uppercase text-thg-tertiary whitespace-nowrap">
                    {item}
                </span>
                <span className="h-1 w-1 bg-thg-red/70" aria-hidden="true" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        className="overflow-hidden border-b border-thg-border py-5"
        aria-hidden="true"
        data-testid="editorial-marquee"
    >
        <div className="thg-marquee-track flex w-max">
            <Row />
            <Row />
        </div>
    </div>
);
